module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("gW4Lw"))).then(() => parcelRequire('ikE14'));